import { Bone } from "@/components/Bone";
import { BoneLine, BonePanel, BoneTitle, Skeleton } from "@/components/PageSkeleton";

import styles from "./Review.module.css";

/** The region's name for a screen reader while the reading's answer loads. */
export const REVIEW_LOADING = "Lesung wird geladen";

/**
 * The review of a reading in its own geometry while the answer is on its way
 * (Task 10; UX review 26.10.2026, B-4), built from the review's classes: the
 * head with title and count; the original and the proposal as two fields at
 * the window's height; the walls' list beside them. Under the frame that
 * already names the Vorgang — never „Schema wird aufgebaut …".
 */
export function ReviewSkeleton() {
  return (
    <Skeleton label={REVIEW_LOADING} className={styles.screen}>
      <div className={styles.head} aria-hidden="true">
        <div className={styles.headRow}>
          <div className={styles.headText}>
            <BoneTitle width="16rem" />
            <BoneLine className={styles.count} width="12rem" />
          </div>
        </div>
      </div>
      <div className={styles.grid} aria-hidden="true">
        {["original", "proposal"].map((pane) => (
          <div key={pane} className={styles.field}>
            <div className={styles.fieldHead}>
              <BoneLine className="label" width="5rem" height="0.625rem" />
            </div>
          </div>
        ))}
        <div className={styles.list}>
          {[0, 1, 2].map((wall) => (
            <BonePanel key={wall}>
              <Bone width="40%" />
              <Bone width="85%" />
            </BonePanel>
          ))}
        </div>
      </div>
    </Skeleton>
  );
}
